<template>
  <ListCommunicationMatter :hasFilterMatter="true"/>
</template>

<script>
import ListCommunicationMatter from '@/views/communications/Communications'
export default {
  name: "Communications",
  components:{
    ListCommunicationMatter,
  },
}
</script>
